import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  z-index: 10000000000;
  top: 0;
  right: 0;

  @media only screen and (min-width: 768px) and (max-width: 1220px) {
    width: calc(100% - 80px);
  }

  @media only screen and (max-width: 767px) {
    width: 100%;
  }
  .sbl-circ-dual {
    width: 140px;
    height: 140px;
    border: 7px solid;
    border-radius: 50%;
    display: inline-block;
    object-fit: contain;
    color: rgba(90, 90, 90, 0.2);
    position: absolute;
    // border-right-color: #3a53a3;
    border-right-color: #01bcec;
    animation: rotate 1s linear infinite;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .logo {
    width: 60px;
    display: block;
  }
  @keyframes rotate {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
